export const SIZES = ['small', 'default', 'big']

export const DEFAULT_SIZE = SIZES[1]

export const KEY_FONT_SIZE = 'fontSize'
export const KEY_THEME = 'theme'